// extracted by mini-css-extract-plugin
module.exports = {"container":"pinnedCards_container__YOL4N","menu":"pinnedCards_menu__arciJ"};